const DEV_CONFIGURATIONS = {
    CLIENT_APP_BRAND: "course_pivot",
    GOOGLE_CLIENT_ID: process.env.REACT_APP_GOOGLE_CLIENT_ID,
    GOOGLE_REDIRECT_URL: process.env.REACT_APP_GOOGLE_REDIRECT_URL,
    API_BASE_URL: process.env.REACT_APP_API_BASE_URL,
    API_BASE_DOMAIN: process.env.REACT_APP_API_BASE_DOMAIN,
    FIREBASE_API_KEY: process.env.REACT_APP_FIREBASE_API_KEY,
    FIREBASE_AUTH_DOMAIN: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    FIREBASE_PROJECT_ID: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    FIREBASE_STORAGE_BUCKET: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    FIREBASE_MESSAGE_SENDER_ID: process.env.REACT_APP_FIREBASE_MESSAGE_SENDER_ID,
    FIREBASE_APP_ID: process.env.REACT_APP_FIREBASE_APP_ID,
    FIREBASE_MEASUREMENT_ID: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
}

export const CONFIGURATIONS = DEV_CONFIGURATIONS
